import { Component, OnInit } from '@angular/core';
import {
  IBillingDocument,
  IOdbBillCoverResponse,
  IEMData,
  IOdbCoverDetail,
  IBillingAccount,
  IOdbCoverDetailDivisionSummaryCategories,
  OdbCoverDetailDivision,
  IBillingBalance,
} from '@dch/billing-business-logic';
import { OnDestroyHookDirective } from '../common/hooks';
import {
  ODB_DETAILS_SESSION_DATA_KEY,
  UtilsService,
} from '../services/utils.service';
import { SelectedOdbDetailsInfo } from '../models/pii.model';
import { selectCustomer } from 'src/app/state/selectors/customer-account.selector';
import { Store } from '@ngrx/store';
import { ApplicationState } from 'src/app/state/reducers';
import { filter, tap } from 'rxjs/operators';
import { Customer } from '@dch/common-business-logic';
import { getBillingCoverRequest } from 'src/app/state/actions/billing-cover.actions';
import { billCoverByDocumentReferenceSelector } from 'src/app/state/selectors/billing-cover.selectors';
import { Observable } from 'rxjs';
import { InceptionService, TranslationService } from '@dch/ng-common';
import { Router } from '@angular/router';
import {
  ONE_DIGITAL_BILL_CATEGORY_DETAILS_PAGE,
  OVERVIEW_PAGE,
} from '../config/my-bill.constants';
import { MessageBoxTypesEnum } from '@dch/pxs-angular-design-system/src/lib/messages/message-box';
import { TransactionReferenceService } from '../services/transaction-reference.service';
@Component({
  selector: 'my-bill-cover-page',
  templateUrl: './cover-page.component.html',
  standalone: false,
})
export class CoverPageComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  readonly selectedCustomer$ = this.store.select(selectCustomer);

  constructor(
    private store: Store<ApplicationState>,
    private utilsService: UtilsService,
    private router: Router,
    private inceptionService: InceptionService,
    private transactionReferenceService: TransactionReferenceService
  ) {
    super();
  }

  billCover$: Observable<IEMData<IOdbBillCoverResponse> | undefined>;
  coverDetails: Array<IOdbCoverDetail> | undefined;
  selectedCustomer: Customer;
  selectedOdbDetailsInfo?: SelectedOdbDetailsInfo;
  billDocument?: IBillingDocument;
  billingAccount?: IBillingAccount;
  openTransactionToPayIndex?: number;
  customerPaymentProfile?: IBillingBalance['customerPaymentProfile'];
  messageBoxTypeError = MessageBoxTypesEnum.Error;
  headerTitle = 'bills.cover.odbDetails.screenTitle';

  ngOnInit() {
    this.selectedOdbDetailsInfo =
      this.utilsService.getInfoFromSessionStorage<SelectedOdbDetailsInfo>(
        ODB_DETAILS_SESSION_DATA_KEY
      );
    const billDocument = this.selectedOdbDetailsInfo?.billDocument;

    if (
      this.selectedOdbDetailsInfo !== undefined &&
      billDocument !== undefined
    ) {
      const {
        billingAccount,
        openTransactionToPayIndex,
        customerPaymentProfile,
      } = this.selectedOdbDetailsInfo;

      this.billDocument = billDocument;
      this.billingAccount = billingAccount;
      this.openTransactionToPayIndex = openTransactionToPayIndex;
      this.customerPaymentProfile = customerPaymentProfile;
      this.fetchCoverPageData();
      this.billCover$ = this.store.select(
        billCoverByDocumentReferenceSelector(
          billingAccount.accountNumber,
          billDocument.reference
        )
      );
      this.fetchTransactionReferencesIfNeeded();
      this.scrollToTop();
    } else {
      this.router.navigate([OVERVIEW_PAGE]);
    }
  }

  fetchTransactionReferencesIfNeeded() {
    if (
      this.selectedCustomer?.subsegment !== 'RES' &&
      this.utilsService.isPeppolUBLXmlApiAvailable()
    ) {
      this.transactionReferenceService
        .isTransactionReferencesLoaded(this.billingAccount?.accountNumber)
        .pipe(
          tap((source) => {
            if (source === undefined) {
              this.transactionReferenceService.fetchTransactionReferences(
                this.billingAccount?.accountNumber
              );
            }
          })
        )
        .subscribe();
    }
  }

  onDetailsClick({
    division,
    category,
    amount,
    address,
  }: {
    division: OdbCoverDetailDivision;
    category?: keyof IOdbCoverDetailDivisionSummaryCategories;
    amount: string;
    address?: string;
  }) {
    this.utilsService.setValueInSessionStorage<SelectedOdbDetailsInfo>(
      ODB_DETAILS_SESSION_DATA_KEY,
      {
        division,
        category,
        amount,
        billDocument: this.billDocument,
        billingAccount: this.billingAccount,
        customerPaymentProfile: this.customerPaymentProfile,
        openTransactionToPayIndex: this.openTransactionToPayIndex,
        address,
      }
    );
    this.router.navigate([ONE_DIGITAL_BILL_CATEGORY_DETAILS_PAGE]);
  }

  private fetchCoverPageData() {
    this.addSubscription(
      this.selectedCustomer$
        .pipe(
          filter((selectedCustomer) => selectedCustomer !== undefined),
          tap((selectedCustomer) => {
            this.selectedCustomer = selectedCustomer;
            const resKey = selectedCustomer.subsegment === 'RES' ? 'RES.' : '';
            this.headerTitle = `bills.cover.odbDetails.${resKey}screenTitle`;
            this.store.dispatch(
              getBillingCoverRequest({
                billingAccountNumber: this.billingAccount.accountNumber,
                reference: this.billDocument.reference,
              })
            );
          })
        )
        .subscribe()
    );
  }

  private scrollToTop(): void {
    setTimeout(() => this.inceptionService.scrollToElement('#maincontent'));
  }
}
